import type { GameStatus } from "../api";

export const GAME_STATUS_LABELS = {
  upcoming: "Upcoming",
  about_to_start: "Open",
  in_progress: "Live",
  finished: "Finished",
} satisfies Record<GameStatus, string>;
